module.exports = __webpack_public_path__ + "img/whatsApp.c1c819e5.png";